const LOGIN_TOKEN_KEY = "v1_login_token";

export function saveLoginToken(token: string | undefined) {
  if (!token) {
    localStorage.removeItem(LOGIN_TOKEN_KEY);
  } else {
    localStorage.setItem(LOGIN_TOKEN_KEY, token);
  }
}

export function getLoginToken() {
  return localStorage.getItem(LOGIN_TOKEN_KEY);
}

export function logout() {
  localStorage.removeItem(LOGIN_TOKEN_KEY);
}
